import React, { FC, useCallback, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { omit, startCase } from 'lodash'
import { getBusinessEntityDetailsData } from '../../../../store/selectors'
import { GreenButton } from '../../../../components/Buttons/GreenButton'
import { UpdateBusinessEntitySettingsModal } from '../UpdateBusinessEntitySettingsModal'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    marginTop: theme.spacing(4),
    padding: theme.spacing(4),
  },
  sectionName: {
    fontSize: 20,
    color: theme.palette.primary.light,
  },
  settingsName: {
    fontWeight: 500,
    fontSize: 22,
    color: theme.palette.primary.light,
    textDecoration: 'underline',
  },
  field: {
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.light,
  },
  fieldTitle: {
    fontWeight: 500,
    fontSize: 20,
  },
  fieldContent: {
    fontSize: 16,
    wordWrap: 'break-word',
  },
}))

export const BusinessEntitySettings: FC = () => {
  const classes = useStyles()
  const { id } = useParams<{ [key: string]: string }>()
  const entity = useSelector(getBusinessEntityDetailsData)

  const [isOpen, setIsOpen] = useState<boolean>(false)

  const onCloseEditModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  const onOpenEditModal = useCallback(() => {
    setIsOpen(true)
  }, [])

  return (
    <>
      <Grid container className={classes.container}>
        <Grid container item xs={8} gap={3}>
          <Typography className={classes.sectionName}>Existing providers</Typography>
        </Grid>
        <Grid container item xs={1} justifyContent={'flex-end'}>
          <GreenButton text="Edit" width={120} onClick={onOpenEditModal} />
        </Grid>
      </Grid>
      {entity?.settings &&
        Object.entries(omit(entity?.settings, ['id', 'updatedAt'])).map(([lib, setting]) => (
          <Grid key={lib} container className={classes.container}>
            <Grid container item xs={8} gap={3}>
              <Grid container item gap={2}>
                <Typography className={classes.settingsName}>
                  {lib === 'b2c2' ? lib.toUpperCase() : startCase(lib)}
                </Typography>
                {Object.entries(setting).map(([key, value], index) => (
                  <Grid key={index} item xs={12} className={classes.field}>
                    <Typography className={classes.fieldTitle}>{startCase(key)}: </Typography>
                    <Typography className={classes.fieldContent}>{value || '-'}</Typography>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        ))}
      <UpdateBusinessEntitySettingsModal id={id} isOpen={isOpen} modalClose={onCloseEditModal} />
    </>
  )
}
